<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Recargar saldo</ion-title>
  </ion-toolbar>
</ion-header>

<div *ngIf="step === 0">
  <p class="ion-text-center">Saldo a recargar (MXN)</p>
  <app-quantity [max]="1000000" [step]="50" [isInput]="true" (quantityChange)="changeQuantity($event)"></app-quantity>
  <p class="ion-text-center">
    Comisión: <strong>{{ commission | percent }}</strong> (Total:
    <strong>{{ recharge * (1 + commission) | currency }})</strong>
  </p>
</div>

<form *ngIf="paymentForm && step === 1" [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
  <ion-grid fixed>
    <ion-row>
      <ion-col size="12">
        <ion-item>
          <ion-input
            label="Número de Tarjeta"
            labelPlacement="floating"
            formControlName="cardNumber"
            type="text"
            inputmode="numeric"
            maxlength="19"
            [errorText]="'Número de tarjeta inválido'"
            [clearInput]="true"
          ></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="3">
        <ion-input
          label="Mes"
          labelPlacement="floating"
          formControlName="expirationMonth"
          type="text"
          inputmode="numeric"
          [errorText]="'El mes debe de ser en 2 dígitos'"
          [clearInput]="true"
        ></ion-input>
      </ion-col>
      <ion-col size="1"> / </ion-col>
      <ion-col size="3">
        <ion-input
          label="Año"
          labelPlacement="floating"
          formControlName="expirationYear"
          type="text"
          inputmode="numeric"
          [errorText]="'El año debe de ser en 2 dígitos'"
          [clearInput]="true"
        ></ion-input>
      </ion-col>
      <ion-col size="5">
        <ion-input
          label="CVV"
          labelPlacement="floating"
          formControlName="cvv"
          type="text"
          inputmode="numeric"
          [errorText]="'CVV debe tener 3 o 4 dígitos'"
          [clearInput]="true"
        ></ion-input>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>

<ion-footer>
  <ion-button
    (click)="next()"
    expand="block"
    fill="clear"
    [disabled]="(step === 0 && !recharge) || (step === 1 && paymentForm?.invalid)"
  >
    <ion-icon *ngIf="step === 1" slot="start" name="cash-outline"></ion-icon>
    <span>{{ step ? 'Pagar ' + (recharge * (1 + commission) | currency) : 'Siguiente' }}</span>
    <ion-icon *ngIf="step === 0" slot="end" name="arrow-forward-outline"></ion-icon>
  </ion-button>
</ion-footer>
